import styled from 'styled-components';

export const Flex = styled.div<{ flexDirection?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${(props) => props.flexDirection};
  > :not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const Circle = styled.div`
  width: 128px;
  height: 128px;
  background-color: #fbf7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;
